
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    export class IcTranTypeGrid extends Serenity.EntityGrid<IcTranTypeRow, any> {
        protected getColumnsKey() { return IcTranTypeColumns.columnsKey; }
        protected getDialogType() { return IcTranTypeDialog; }
        protected getIdProperty() { return IcTranTypeRow.idProperty; }
        protected getInsertPermission() { return IcTranTypeRow.insertPermission; }
        protected getLocalTextPrefix() { return IcTranTypeRow.localTextPrefix; }
        protected getService() { return IcTranTypeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}